import type { CheckPLgPermissionOptions } from '@/domains/novelty-check-report/services/novelty-check-permission-service';

/**
 * DesignFTO模块编辑权限服务
 *
 * 用于判断当前用户是否有权限编辑DesignFTO模块内容
 */
export interface DesignFtoPermissionService {
    /**
     * 判断是否允许编辑DesignFTO模块
     *
     * @returns 如果是企业租户则返回 true，否则返回 false
     */
    canEdit(): boolean;

    /**
     * 检查 PLG 权限
     * 如果有编辑权限则调用回调函数
     * 如果没有权限则打开升级套餐对话框并抛出错误
     *
     * @param callback - 有权限时执行的回调函数
     * @param options - PLG 权限检查选项
     * @returns Promise<void>
     */
    checkPLgPermission(callback?: () => void | Promise<void>, options?: CheckPLgPermissionOptions): Promise<void>;
}

export const DesignFtoPermissionService = Symbol.for('DesignFtoPermissionService');
